import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Input,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
  Switch,
} from "@chakra-ui/react";
import React, { memo, useMemo, useEffect, useState, useCallback } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import imageIcon from "../../../assets/images/booking/image.svg";
import iconTrash from "../../../assets/images/projectManagement/trash-2.svg";
import iconPlus from "../../../assets/images/projectManagement/plus.svg";
import calendarIcon from "../../../assets/images/onleave/calendar.svg";
import {
  InputControl,
  SelectControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { FormBonus } from "../../../components/form/formBonus";
import { useCategories } from "../../../categorys/locking/detail";
import { lockingImageCall } from "../../../api/lockingImage";
import { lockingParticipantCall } from "../../../api/lockingParticipant";
import DatePicker from "react-datepicker";
import { formatPriceUS } from "../../../utils/utils";
import { useApartment } from "../../../hooks/useApartments";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { saleOpeningEventCall } from "../../../api/saleOpeningEvent";
import { bookingCall } from "../../../api/booking";
import { useRef } from "react";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({
  // price: Yup.number()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string" && originalValue.trim() === "") {
  //       return null;
  //     }
  //     return Number(originalValue);
  //   })
  //   .typeError("Số tiền cọc phải là một số hợp lệ")
  //   .moreThan(0, "Số tiền cọc phải lớn hơn 0")
  //   .required("Vui lòng nhập số tiền cọc"),
  // bookerId: Yup.string().required("Vui lòng chọn nhân viên tạo"),
  // paymentMethodId: Yup.string().required(
  //   "Vui lòng chọn phương thức thanh toán"
  // ),
  // customerId: Yup.string().required("Vui lòng chọn khách hàng"),
  // apartmentId: Yup.string().required("Vui lòng chọn sản phẩm"),
  // projectId: Yup.string().required("Vui lòng chọn dự án"),
  // bookingTime: Yup.string().required("Vui lòng chọn thời gian"),
  // saleOpeningEventId: Yup.string().required("Vui lòng chọn đợt mở bán"),
  // delegationImage: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test("check-empty", "Vui lòng chọn ảnh ủy nhiệm chi", (value) => {
  //     return Array.isArray(value) && value.length > 0;
  //   })
  //   .test("check-status", "Vui lòng chọn ảnh và upload ảnh", (value) => {
  //     if (!Array.isArray(value) || value.length === 0) return true;
  //     return value.every((img) => img.status === true);
  //   }),
  employeeProject: Yup.array()
    .of(
      Yup.object({
        id: Yup.mixed().required(),
        employeeId: Yup.string().required("Vui lòng chọn nhân viên"),
        commissionRate: Yup.string().required("Vui lòng nhập phí dịch vụ"),
      }),
    )
    .test("check-empty", "Vui lòng thêm nhân viên tham gia", (value) => {
      return Array.isArray(value) && value.length > 0;
    })
    .test(
      "check-fields",
      "Vui lòng điền đầy đủ thông tin nhân viên tham gia và tỉ lệ",
      function (value) {
        if (!Array.isArray(value)) return true;

        const hasIncomplete = value.some(
          (item) => !item.employeeId || !item.commissionRate,
        );

        if (hasIncomplete) {
          return this.createError({
            message:
              "Vui lòng điền đầy đủ thông tin nhân viên tham gia và tỉ lệ",
            path: this.path,
          });
        }

        return true;
      },
    )
    .test(
      "check-total-equal",
      "Tổng tỉ lệ các nhân viên tham gia phải bằng 100%",
      function (value) {
        if (!Array.isArray(value)) return true;

        const total = value.reduce((sum, item) => {
          const rate = parseFloat(item.commissionRate);
          return sum + (isNaN(rate) ? 0 : rate);
        }, 0);

        // Làm tròn để tránh lỗi do số thập phân
        if (Math.round(total * 100) / 100 !== 100) {
          return this.createError({
            message: "Tổng tỉ lệ các nhân viên tham gia phải bằng 100%",
            path: this.path,
          });
        }

        return true;
      },
    ),
});

const FormDetail = memo(
  ({ isOpen, onClose, onSubmit, defaultValues, isEdit }) => {
    const {
      reset,
      register,
      handleSubmit,
      watch,
      setValue,
      setError,
      getValues,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: defaultValues || {},
    });

    const [errorData, setErrorData] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(null);
    const [focusStates, setFocusStates] = useState({});

    const [isLoadingUpload, setIsloadingUpload] = useState(false);
    const [delegationImage, setDelegationImage] = useState([]);
    const [delegationImageError, setDelegationImageError] = useState(false);
    const imageRefs = useRef([]);

    const [employeeProject, setEmployeeProject] = useState([
      {
        id: Date.now(),
        employeeId: "",
        employeeJobTitle: "",
        commissionRate: "",
      },
    ]);
    const [displayPrice, setDisplayPrice] = useState(0);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [checkedSwitch, setCheckedSwitch] = useState(
      defaultValues?.isWrongInput || false,
    );
    const onChangePrice = useCallback(
      (event) => {
        const { value } = event.target;
        const numericValue = value.replace(/[^0-9]/g, "");
        setDisplayPrice(formatPriceUS(numericValue));
        setValue("price", Number(numericValue), {
          shouldValidate: true,
        });
      },
      [setValue, watch, formatPriceUS],
    );

    useEffect(() => {
      const timer = setTimeout(() => {
        setShouldFetch(true);
      }, 1200);

      return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
      setValue("delegationImage", delegationImage);
      if (
        delegationImage?.length > 0 &&
        delegationImage?.filter((img) => img.status === false)
      ) {
        setDelegationImageError(true);
      } else {
        setDelegationImageError(false);
      }
    }, [delegationImage, setValue]);

    useEffect(() => {
      setValue("employeeProject", employeeProject);
    }, [employeeProject, setValue]);

    const { constantData } = useCategories(
      null,
      null,
      1,
      watch("bookerId") || defaultValues?.bookerId,
      shouldFetch,
    );
    const { apartmentData } = useApartment(
      "",
      watch("projectId") || defaultValues?.projectId,
    );

    const formatEntries = (entries) =>
      Object.entries(entries || {}).map(([key, value]) => ({
        value: key,
        label: value,
      }));

    const formatEntrieAps = (entries) =>
      Object.entries(entries || {}).map(([key, value]) => ({
        value: key,
        label: value.name,
        code: value.code,
      }));

    const apartmentConstantData = apartmentData?.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    const projects = useMemo(
      () => formatEntries(constantData?.project),
      [constantData?.project],
    );
    // const apartments = useMemo(
    //   () => formatEntrieAps(constantData?.apartment),
    //   [constantData?.apartment]
    // );
    const apartments = useMemo(
      () => formatEntrieAps(apartmentConstantData),
      [apartmentData],
    );
    const customers = useMemo(
      () => formatEntries(constantData?.customer),
      [constantData?.customer],
    );
    const employees = useMemo(() => {
      if (!constantData?.employeeDepartMent) return [];

      return Object.entries(constantData.employeeDepartMent).map(
        ([id, { fullName, code }]) => ({
          value: id,
          label: `${fullName} (${code})`,
        }),
      );
    }, [constantData?.employeeDepartMent]);
    const employeeDatas = useMemo(() => {
      if (!constantData?.employeeData) return [];

      return Object.entries(constantData.employeeData).map(
        ([id, { fullName, code }]) => ({
          value: id,
          label: `${fullName} (${code})`,
        }),
      );
    }, [constantData?.employeeData]);
    const paymentMethods = useMemo(
      () => formatEntries(constantData?.paymentMethod),
      [constantData?.paymentMethod],
    );
    const saleOpeningEvents = useMemo(
      () => formatEntries(constantData?.saleOpeningEvent),
      [constantData?.saleOpeningEvent],
    );
    const bookings = useMemo(
      () => formatEntrieAps(constantData?.booking),
      [constantData?.booking],
    );

    useEffect(() => {
      reset(defaultValues);
      setErrorData(false);
      if (defaultValues) {
        setDisplayPrice(formatPriceUS(defaultValues?.price || 0));
      } else {
        setDisplayPrice(formatPriceUS(0));
      }
      // lấy ra nhân viên quản lý
      if (defaultValues?.id) {
        const fetchData = async () => {
          try {
            const dataManagerEmployee =
              await lockingParticipantCall.getByLockingId(defaultValues?.id);

            setEmployeeProject(dataManagerEmployee);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
      } else {
        setEmployeeProject([
          {
            id: Date.now(),
            employeeId: "",
            employeeJobTitle: "",
            commissionRate: "",
          },
        ]);
      }

      // lấy ra ảnh

      if (defaultValues?.id) {
        if (Array.isArray(defaultValues?.images)) {
          const initImages = defaultValues?.images?.map((image, idx) => ({
            id: image?._id || Date.now() + idx,
            path: image?.path || "",
            imageUrl: null,
            file: null,
            status: true, // ảnh đã upload
          }));
          setDelegationImage(initImages);
        }
      }
    }, [isOpen]);

    //Thêm nhân viên
    const addEmployee = () => {
      setEmployeeProject([
        ...employeeProject,
        {
          id: Date.now(),
          employeeId: "",
          employeeJobTitle: "",
          commissionRate: "",
        },
      ]);
    };

    // Hàm xóa nhân viên
    const deleteEmployee = (id) => {
      setEmployeeProject(employeeProject.filter((emp) => emp.id !== id));
      clearErrors("employeeProject");
    };

    // Hàm thay đổi dữ liệu
    const handleChange = (id, field, value) => {
      const isDuplicate =
        field === "employeeId" &&
        employeeProject.some(
          (emp) => emp.id !== id && emp.employeeId === value,
        );

      if (isDuplicate) {
        setError("employeeProject", {
          type: "manual",
          message: "Nhân viên đã được chọn vui lòng chọn lại",
        });

        return;
      } else {
        clearErrors("employeeProject");
      }

      setEmployeeProject((prev) =>
        prev.map((emp) => (emp.id === id ? { ...emp, [field]: value } : emp)),
      );
    };

    const handleFocus = (field, index) => {
      if (index !== null) {
        setFocusedIndex(index);
      } else {
        setFocusStates((prev) => ({ ...prev, [field]: true }));
      }
    };

    const handleBlur = (field, index) => {
      if (index !== null) {
        setFocusedIndex(index);
      } else {
        setFocusedIndex(null);
      }
      setFocusStates((prev) => ({ ...prev, [field]: false }));
    };

    // xử lý chọn nhiều ảnh
    const handleAddDelegationImage = () => {
      setDelegationImage((prev) => {
        const newImage = {
          id: Date.now(),
          path: null,
          imageUrl: null,
          file: null,
          status: false,
        };

        setTimeout(() => {
          const index = prev.length; // index mới
          imageRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100); // để DOM cập nhật xong mới scroll

        return [...prev, newImage];
      });
    };

    // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
    const handleUploadDelegationImage = async (index, selectedFile) => {
      const file = selectedFile || delegationImage[index]?.file;
      if (!file) return;

      // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
      const updateImage = (data) =>
        setDelegationImage((prev) => {
          const position = prev.findIndex((item) => item?.file === file);
          if (position < 0) return prev;
          const updated = [...prev];
          updated[position] = { ...updated[position], ...data };
          return updated;
        });

      updateImage({ uploading: true });

      try {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage",
        );

        if (filePath) {
          updateImage({ path: filePath, status: true, uploading: false });
          toast.success("Upload ảnh thành công");
          clearErrors("delegationImage");
        } else {
          updateImage({ uploading: false });
          toast.error("Upload thất bại");
        }
      } catch (error) {
        // commonCall.uploadFile đã báo lỗi bằng toast
        updateImage({ uploading: false });
      }
    };

    const handleChangeDelegationImage = (e, index) => {
      const file = e.target.files[0];
      if (!file) return;

      const imageUrl = URL.createObjectURL(file);
      const updated = [...delegationImage];
      updated[index] = {
        ...updated[index],
        file,
        imageUrl,
        status: false,
        path: null,
      };
      setDelegationImage(updated);
      handleUploadDelegationImage(index, file);
    };

    const handleRemoveDelegationImage = (index) => {
      const updated = [...delegationImage];
      updated.splice(index, 1);
      setDelegationImage(updated);
      if (delegationImage?.length === 0) {
        setDelegationImageError(false);
      }
    };

    const handleDateChange = (e, inputName) => {
      setValue(inputName, e, { shouldValidate: true });
      // const selectedDate = e.target.value;

      // setInputColors((prevColors) => ({
      //   ...prevColors,
      //   [inputName]: selectedDate
      //     ? "var(--color-info-employee)"
      //     : "var(--color-text-unclick)",
      // }));
    };

    const onchangeProject = (option) => {
      setValue("projectId", option);
    };

    const onchangeApartment = (option) => {
      setValue("apartmentId", option);
    };

    const onchangeCustomer = (option) => {
      setValue("customerId", option);
    };

    const onchangePaymentMethod = (option) => {
      setValue("paymentMethodId", option);
    };

    const onchangeEmpoyeeList = (option) => {
      setValue("bookerId", option);
    };

    const onchangeSaleOpeningEvents = async (option) => {
      setValue("saleOpeningEventId", option);
      // setValue("bookingId", "");

      try {
        let data = await saleOpeningEventCall.getId(option);

        if (data?.projectId) {
          setValue("projectId", data?.projectId);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const onchangeBookings = async (option) => {
      setValue("bookingId", option);
      // setValue("saleOpeningEventId", "");

      try {
        let data = await bookingCall.getId(option);

        if (data?.projectId) {
          setValue("projectId", data?.projectId);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const submitHandler = (data) => {
      console.log("hoang dahihag");
      employeeProject.forEach((employee) => {
        if (!employee.employeeJobTitle) {
          delete employee.employeeJobTitle;
        }
      });
      data.employeeProject = employeeProject;

      // console.log(data);
      onSubmit(data);
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"625px"}
        >
          <form onSubmit={handleSubmit(submitHandler)}>
            <Box
              // paddingBottom={"80px"}
              h={"86.5vh"}
              w={"100%"}
              overflowY={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex
                alignItems={"center"}
                p={"25px 24px 24px 24px"}
                position={"relative"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  {isEdit ? "Chỉnh sửa locking" : "Thêm locking"}
                </Text>
                <Box
                  position={"absolute"}
                  top={"24px"}
                  right={"24px"}
                  cursor={"pointer"}
                  onClick={onClose}
                >
                  <Image src={IconX} />
                </Box>
              </Flex>
              <Box margin={"0 auto"}>
                <Box p={"24px 40px"}>
                  <Box flex={1}>
                    <Box>
                      <Text
                        color={"var(--color-header-employee)"}
                        fontSize={"16px"}
                        fontWeight={"600"}
                      >
                        Thông tin chung
                      </Text>
                      <Box mt={"16px"} borderRadius={"8px"}>
                        <Flex>
                          <InputControl
                            label="Tên đợt locking"
                            placeholder="Nhập tên đợt locking"
                            errors={errors.note}
                            register={register("note")}
                            onFocus={() => handleFocus("note")}
                            onBlur={() => handleBlur("note")}
                            state={focusStates["note"]}
                            mwidth="100%"
                          />
                        </Flex>
                        {isEdit && (
                          <Flex mt={"12px"} gap={"27px"}>
                            {/* <Box flex={"1"}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Người tạo locking
                              </Text>
                              <Text
                                color={"var(--color-option-employee)"}
                                fontSize={"14px"}
                                fontWeight={"500"}
                                mt={"8px"}
                              >
                                Nguyễn Thục Quyên
                              </Text>
                            </Box> */}
                            {defaultValues?.createdAt && (
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày tạo locking
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {defaultValues?.createdAt}
                                </Text>
                              </Box>
                            )}
                          </Flex>
                        )}

                        <Flex mt={"16px"} gap={"27px"}>
                          <SelectControl
                            label="Đợt mở bán"
                            dataOption={saleOpeningEvents}
                            placeholder="Chọn đợt mở bán"
                            selectedMain={watch("saleOpeningEventId")}
                            onChange={onchangeSaleOpeningEvents}
                            onFocus={() => handleFocus("saleOpeningEventId")}
                            onBlur={() => handleBlur("saleOpeningEventId")}
                            state={focusStates["saleOpeningEventId"]}
                            registerProps={register("saleOpeningEventId")}
                            errorMessage={errors.saleOpeningEventId}
                            mwidth="259px"
                            isSearchable={true}
                            // isRequired={true}
                          />
                          <SelectControl
                            label="Booking"
                            dataOption={bookings}
                            placeholder="Chọn booking"
                            selectedMain={watch("bookingId")}
                            onChange={onchangeBookings}
                            onFocus={() => handleFocus("bookingId")}
                            onBlur={() => handleBlur("bookingId")}
                            state={focusStates["bookingId"]}
                            registerProps={register("bookingId")}
                            errorMessage={errors.bookingId}
                            mwidth="100%"
                            isSearchable={true}
                            getCode={true}
                            // // isRequired={true}
                          />
                        </Flex>

                        <Flex mt={"16px"} gap={"27px"}>
                          <SelectControl
                            label="Dự án"
                            dataOption={projects}
                            placeholder="Chọn dự án"
                            selectedMain={watch("projectId")}
                            onChange={onchangeProject}
                            onFocus={() => handleFocus("projectId")}
                            onBlur={() => handleBlur("projectId")}
                            state={focusStates["projectId"]}
                            registerProps={register("projectId")}
                            errorMessage={errors.projectId}
                            mwidth="259px"
                            isSearchable={true}
                            // isRequired={true}
                          />
                          <SelectControl
                            label="Sản phẩm"
                            dataOption={apartments}
                            placeholder="Chọn sản phẩm"
                            selectedMain={watch("apartmentId")}
                            onChange={onchangeApartment}
                            onFocus={() => handleFocus("apartmentId")}
                            onBlur={() => handleBlur("apartmentId")}
                            state={focusStates["apartmentId"]}
                            registerProps={register("apartmentId")}
                            errorMessage={errors.apartmentId}
                            mwidth="100%"
                            isSearchable={true}
                            getCode={true}
                            // isRequired={true}
                          />
                        </Flex>
                        <Flex mt={"16px"} gap={"27px"}>
                          <InputControl
                            // type="number"
                            label="Số tiền cọc"
                            placeholder="Ví dụ: 1 tỷ 950 triệu "
                            errors={errors.price}
                            register={register("price")}
                            onFocus={() => handleFocus("price")}
                            onBlur={() => handleBlur("price")}
                            state={focusStates["price"]}
                            onChange={onChangePrice}
                            value={displayPrice}
                            mwidth={"100%"}
                            // isRequired={true}
                          />
                          <FormControl flex={1} zIndex={3}>
                            <FormLabel
                              mb={"6px"}
                              fontSize={{ base: "12px" }}
                              fontWeight={400}
                              color={
                                focusStates["startTime"]
                                  ? "var(--color-option-employee-hover)"
                                  : "var(--color-label-employee)"
                              }
                              display={"flex"}
                              gap={"4px"}
                            >
                              TG đặt cọc
                              {/* <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text> */}
                            </FormLabel>
                            <InputGroup>
                              <DatePicker
                                width="100%"
                                selected={watch("bookingTime")}
                                onChange={(date) =>
                                  handleDateChange(date, "bookingTime")
                                }
                                dateFormat="dd/MM/yyyy"
                                locale="vi"
                                placeholderText="dd/mm/yy"
                                className="custom-datepicker datePickerStyle"
                                onFocus={() =>
                                  handleFocus("bookingTime", "bookingTime")
                                }
                                onBlur={() => handleBlur("bookingTime")}
                              />
                              <InputRightElement
                                pointerEvents="none"
                                h={"44px"}
                              >
                                <Image src={calendarIcon} />
                              </InputRightElement>
                            </InputGroup>
                            {errors.bookingTime && (
                              <Text fontSize={{ base: "12px" }} color={"red"}>
                                {errors.bookingTime.message}
                              </Text>
                            )}
                          </FormControl>
                          {/* <InputControl
                            label={"TG bắt đầu"}
                            type="date"
                            colorIp={inputColors.bookingTime}
                            state={focusStates["bookingTime"]}
                            onFocus={() => handleFocus("bookingTime")}
                            onBlur={() => handleBlur("bookingTime")}
                            onChange={(e) => handleDateChange(e, "bookingTime")}
                            valueMain={watch("bookingTime")}
                            errors={errors?.bookingTime}
                            register={register("bookingTime")}
                          /> */}
                        </Flex>
                        <Flex mt={"16px"} gap={"27px"}>
                          <SelectControl
                            label="Phương thức thanh toán"
                            dataOption={paymentMethods}
                            placeholder="Chọn phương thức thanh toán"
                            selectedMain={watch("paymentMethodId")}
                            onChange={onchangePaymentMethod}
                            onFocus={() => handleFocus("paymentMethodId")}
                            onBlur={() => handleBlur("paymentMethodId")}
                            state={focusStates["paymentMethodId"]}
                            registerProps={register("paymentMethodId")}
                            errorMessage={errors.paymentMethodId}
                            mwidth="100%"
                            // isRequired={true}
                            isSearchable={true}
                          />
                        </Flex>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"27px"}
                          mt={"16px"}
                        >
                          <SelectControl
                            label={"Nhân viên tạo"}
                            dataOption={employeeDatas}
                            placeholder="Chọn nhân viên"
                            selectedMain={watch("bookerId")}
                            onChange={onchangeEmpoyeeList}
                            onFocus={() => handleFocus("bookerId")}
                            onBlur={() => handleBlur("bookerId")}
                            state={focusStates["bookerId"]}
                            registerProps={register("bookerId")}
                            errorMessage={errors.bookerId}
                            mwidth="100%"
                            isSearchable={true}
                            // isRequired={true}
                          />
                        </Flex>

                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"27px"}
                          mt={"16px"}
                        >
                          <Box>
                            <Text
                              lineHeight={"15px"}
                              m="0"
                              fontSize={{ base: "12px" }}
                              mb={"6px"}
                              fontWeight={400}
                              color={"var(--color-label-employee)"}
                            >
                              GD thiếu lịch sử Lead/Tư vấn
                            </Text>
                            <Switch
                              {...register("isWrongInput")}
                              checked={checkedSwitch}
                              onChange={(e) =>
                                setCheckedSwitch(e.target.checked)
                              }
                            />
                          </Box>
                        </Flex>
                      </Box>
                    </Box>
                  </Box>
                  <Box flex={1} mt={"24px"}>
                    <Box>
                      <Text
                        color={"var(--color-header-employee)"}
                        fontSize={"16px"}
                        fontWeight={"600"}
                      >
                        Thông tin khách hàng
                      </Text>
                      <Box
                        background={"var(--fill-avatar)"}
                        p={"16px 24px 16px 16px"}
                        mt={"16px"}
                        borderRadius={"8px"}
                      >
                        <Flex gap={"27px"}>
                          <Box flex={"1"}>
                            <SelectControl
                              label="Tên khách hàng"
                              dataOption={customers}
                              placeholder="Chọn khách hàng"
                              selectedMain={watch("customerId")}
                              onChange={onchangeCustomer}
                              onFocus={() => handleFocus("customerId")}
                              onBlur={() => handleBlur("customerId")}
                              state={focusStates["customerId"]}
                              registerProps={register("customerId")}
                              errorMessage={errors.customerId}
                              mwidth="259px"
                              isSearchable={true}
                              // isRequired={true}
                            />
                          </Box>
                        </Flex>
                      </Box>
                    </Box>

                    {/* Ảnh UNC mới */}
                    <Box flex={1} mt={"24px"}>
                      <Box mt={6}>
                        <Flex justify="space-between" align="center" mb={2}>
                          <Flex alignItems="center" gap="4px">
                            <Text
                              color={"var(--color-label-employee)"}
                              fontSize={"12px"}
                            >
                              Ảnh ủy nhiệm chi
                            </Text>
                            {/* <Text
                              fontSize={{ base: "12px" }}
                              color={"red"}
                              lineHeight={"15px"}
                            >
                              *
                            </Text> */}
                          </Flex>

                          <Button size="sm" onClick={handleAddDelegationImage}>
                            + Thêm ảnh
                          </Button>
                        </Flex>

                        {delegationImage.map((img, index) => (
                          <Box
                            key={img.id || index}
                            mb={4}
                            ref={(el) => (imageRefs.current[index] = el)}
                          >
                            <Flex
                              border="1px solid #ccc"
                              borderRadius="8px"
                              p={2}
                              align="center"
                              gap={4}
                              position={"relative"}
                              justifyContent={"center"}
                            >
                              <Box w="100%" h="200px" position="relative">
                                {img.imageUrl || img.path ? (
                                  <Image
                                    src={
                                      img.imageUrl || `${baseURL}/${img.path}`
                                    }
                                    objectFit="contain"
                                    w="100%"
                                    h="100%"
                                    borderRadius="8px"
                                  />
                                ) : (
                                  <Text
                                    fontSize="sm"
                                    color="gray.400"
                                    textAlign="center"
                                    mt="80px"
                                  >
                                    Chưa có ảnh
                                  </Text>
                                )}

                                <Input
                                  type="file"
                                  accept="image/*"
                                  opacity={0}
                                  position="absolute"
                                  top={0}
                                  left={0}
                                  w="100%"
                                  h="100%"
                                  cursor="pointer"
                                  onChange={(e) =>
                                    handleChangeDelegationImage(e, index)
                                  }
                                />
                              </Box>

                              <Box
                                position="absolute"
                                top="8px"
                                right="8px"
                                zIndex={2}
                              >
                                <Button
                                  size="sm"
                                  colorScheme="red"
                                  onClick={() =>
                                    handleRemoveDelegationImage(index)
                                  }
                                >
                                  Xóa
                                </Button>
                              </Box>
                            </Flex>
                            {!img.imageUrl && !img?.status && (
                              <Text
                                fontSize="12px"
                                color="red"
                                lineHeight={"15px"}
                                mt={"8px"}
                                textAlign={"right"}
                              >
                                Vui lòng chọn ảnh
                              </Text>
                            )}
                            {img.imageUrl && !img.status && (
                              <Text
                                fontSize="12px"
                                color="red"
                                lineHeight={"15px"}
                                mt={"8px"}
                                textAlign={"right"}
                              >
                                {img.uploading
                                  ? "Đang tải ảnh lên..."
                                  : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                              </Text>
                            )}
                            <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                              {!img.status && img.file && (
                                <Button
                                  bg={"var(--linear-gradient-employee)"}
                                  color={"var(--color-main)"}
                                  fontSize={"12px"}
                                  lineHeight={"17px"}
                                  // p={"6px 27px 5px 28px"}
                                  fontWeight={"600"}
                                  _hover={{
                                    filter: "brightness(90%)",
                                  }}
                                  onClick={() =>
                                    handleUploadDelegationImage(index)
                                  }
                                  isDisabled={!img.file}
                                  h={"28px"}
                                  minH={"28px"}
                                  w={"90px"}
                                  isLoading={isLoadingUpload || img.uploading}
                                >
                                  Tải lại
                                </Button>
                              )}
                            </Flex>
                          </Box>
                        ))}

                        {errors?.delegationImage?.message &&
                          !delegationImageError && (
                            <Text
                              fontSize="12px"
                              color="red"
                              lineHeight={"15px"}
                            >
                              {errors?.delegationImage?.message}
                            </Text>
                          )}
                      </Box>
                    </Box>
                  </Box>
                  <Box margin={"24px auto"}>
                    <Flex flexDirection={"column"} gap={"16px"}>
                      <Flex
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Text
                          fontSize={"16px"}
                          fontWeight={600}
                          lineHeight={"normal"}
                          color="var(--color-black)"
                        >
                          Nhân viên tham gia
                        </Text>
                      </Flex>
                      <Flex
                        mt={"12px"}
                        flexDirection={"column"}
                        gap={"12px"}
                        alignItems={"flex-end"}
                      >
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"flex-start"}
                          gap={"12px"}
                          w={"100%"}
                          flexDirection={"column"}
                        >
                          {employeeProject.map((emp, index) => (
                            <FormBonus
                              key={index}
                              zIndex={index}
                              titleRate="Tỉ lệ"
                              isIconPlace={true}
                              isIconTime={false}
                              length={"100%"}
                              onChangeName={(e) => {
                                handleChange(emp.id, "employeeId", e);
                              }}
                              onChangeBonus={(e) => {
                                handleChange(emp.id, "commissionRate", e);
                              }}
                              onChangeJobTitle={(e) => {
                                handleChange(emp.id, "employeeJobTitle", e);
                              }}
                              deleteData={() => deleteEmployee(emp.id)}
                              icon={iconTrash}
                              nameMain={emp?.commissionRate || null}
                              jobTitleMain={emp?.employeeJobTitle || null}
                              selectedMain={emp.employeeId}
                              filteredOptions={employeeDatas}
                              isFocused={focusedIndex === index}
                              onFocus={() =>
                                handleFocus("managerProject", index)
                              }
                              onBlur={() => handleBlur("managerProject", index)}
                              // required={true}
                            />
                          ))}
                        </Flex>
                        {errors?.employeeProject?.message && (
                          <Text
                            w={"100%"}
                            color={"var(--text-red-employee)"}
                            fontSize={"12px"}
                          >
                            {errors?.employeeProject?.message}
                          </Text>
                        )}
                        <Flex
                          gap={"4px"}
                          alignItems={"end"}
                          p="8px 16px"
                          border={
                            "1px solid var(--color-option-employee-hover)"
                          }
                          borderRadius={"8px"}
                          w={"max-content"}
                          mr={"60px"}
                          cursor={"pointer"}
                          bg={"var(--color-main)"}
                          onClick={addEmployee}
                          _hover={{
                            filter: "brightness(90%)",
                          }}
                        >
                          <Image src={iconPlus} />
                          <Text
                            fontSize={"12px"}
                            lineHeight={"15px"}
                            color={"var(--color-option-employee-hover)"}
                            fontWeight={600}
                          >
                            Thêm NV tham gia
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Box>
                </Box>
              </Box>
              <Box
                // position={"absolute"}
                w={"100%"}
                // bottom={"0"}
                bg={"var(--color-main)"}
                borderTop={"0.5px solid var(--bg-line-employee)"}
                borderRadius={"0px 0px 16px 16px"}
                zIndex={3}
              >
                <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                  <Button
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    borderRadius={"8px"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    onClick={onClose}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Lưu
                  </Button>
                </Flex>
              </Box>
            </Box>
          </form>
        </ModalContent>
      </Modal>
    );
  },
);

export default FormDetail;
